module.exports = __webpack_public_path__ + "img/Bumper.efd3bb60.png";